<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    this.$store.commit("eduWebConfig/getEduWebConfigInfo"); // 根据域名获取当前网页配置参数
  },
};
</script>

<style >
@import "../static/css/global.css";
</style>
<style lang="scss">
$themeColor: #091d7c;

html {
  overflow: hidden;
}

body {
  margin: 0px;
  padding: 0px;
  font-family: Microsoft YaHei, Helvetica Neue, Helvetica, PingFang SC,
    Hiragino Sans GB, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

element.style {
  background-color: red !important;
}

.el-dialog {
  .el-dialog__header {
    background-image: linear-gradient(45deg, #081a8f, #5548eb);
    padding: 0;
    height: 55px;
    line-height: 55px;
    padding-left: 20px;

    .el-dialog__headerbtn .el-dialog__close {
      color: white;
      font-size: 20px;
    }
  }

  .el-dialog__title {
    color: white;
    font-weight: 400;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }

  width: 50%;

  .el-form-item {
    width: 60%;
    margin: 0;
    margin-left: 15%;
    margin-bottom: 15px;
  }

  .el-divider {
    margin: -20px 0 20px;
  }

  .el-form-item__label {
    line-height: 50px;
  }

  .el-input {
    width: 100%;
    height: 50px;
    line-height: 50px;
  }

  .el-cascader {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-radio {
    line-height: 50px !important;
    height: 100%;
  }

  .is-checked {
    .el-radio__inner {
      background-color: #091d7c;
      border-color: #091d7c;
    }

    .el-radio__label {
      color: #091d7c;
    }
  }

  .dialog-footer .el-button:nth-child(2) {
    background-color: #091d7c;
    color: white;
  }

  .el-button--primary {
    border-color: inherit;
  }
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

a {
  color: #56a9ff;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

// 表格按钮头部统一样式
.btnsColor {
  background-color: #091d7c;
  border: none;
  font-size: 14.5px;
  height: 34px;
  min-width: 70px;
}

.circularBtn {
  height: 34px;
  width: 34px;
  color: #091d7c;
  border: none;
  padding: 0;

  i {
    font-size: 20px;
    font-weight: 600;
  }
}

.headerClass {
  font-size: 14px;
}

// table切换头样式
.el-tabs__item.is-active {
  color: #091d7c;
}

.is-active {
  color: #091d7c;
}

.el-tabs__active-bar {
  background-color: #091d7c;
}

.el-tabs__item:hover {
  color: #091d7c;
}

// 多选框样式
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: white;
  border-color: #091d7c;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #091d7c;
}

.el-checkbox.is-bordered.is-checked {
  border-color: #091d7c;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #091d7c;
}

.el-checkbox__inner:hover {
  border-color: #091d7c;
}

.el-checkbox__inner::after {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  border: 2px solid #091d7c;
  //   border: 1px solid #FFF;
  content: "";
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  -webkit-transform: rotate(45deg) scaleY(0);
  transform: rotate(45deg) scaleY(0);
  width: 3px;
}

.el-table {
  .el-checkbox__inner {
    height: 18px;
    width: 18px;
  }

  .el-checkbox__inner::after {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    border: 2px solid #091d7c;
    //   border: 1px solid #FFF;
    content: "";
    border-left: 0;
    border-top: 0;
    height: 9px;
    left: 6px;
    position: absolute;
    top: 1px;
    -webkit-transform: rotate(45deg) scaleY(0);
    transform: rotate(45deg) scaleY(0);
    width: 3px;
  }
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  content: "";
  position: absolute;
  display: block;
  background-color: #091d7c;
  height: 4px;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 40%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue